import React, {useEffect} from "react";
import { Route, Routes } from "react-router-dom";
import SystemManageLayout from "../../components/layouts/SystemManageLayout";

import Category from "./Category";
import Article from "./Article";
import Banner from "./Banner";
import ArticleInfo from "./Article/ArticleInfo";
import ArticleAbout from "./Article/ArticleAbout";
import ArticleContact from "./Article/ArticleContact";

const SystemManage = () => {

  useEffect(() => {
    document.title = "和映官网后台管理";
  }, []);

  return (
    <SystemManageLayout>
      <Routes>
        <Route path="/" element={<Banner />} />
        <Route path="category" element={<Category />} />
        <Route path="article" element={<Article />} />
        <Route path="article/create" element={<ArticleInfo />} />
        <Route path="article/info/:article_id" element={<ArticleInfo />} />
        <Route path="article_about" element={<ArticleAbout />} />
        <Route path="article_contact" element={<ArticleContact />} />
      </Routes>
    </SystemManageLayout>
  );
};

export default SystemManage;